<template>
  <div>
    <donut-alert v-if="displayLogic.alert" v-bind="displayLogic.alert" class="m-bx3" />
    <donut-page-sections-two-column title="Recipients" :description="displayLogic.description">
      <template #right-side>
        <div v-for="(section, idx) in displayLogic.sections" :key="idx" class="m-bx2">
          <div v-if="section === 'active-hris'">
            <integrations-recipients-rule-accordion
              update-path="/bonus/milestones/update_enrollment_rules"
              :hris-categories="hrisCategories"
              things-text="Send milestone bonuses to"
              everyone-description="If you have people in your workspace with Celebrations dates who are not listed in your HRIS, they will still be included in automated milestone bonuses."
              not-eligible-text="for milestone bonuses"
            />
          </div>
          <div v-if="section === 'inactive-hris'">
            <div class="t bold">Sync dates from your HRIS</div>
            <div class="t m-tx1">For 100% coverage, connect your HRIS to automatically sync all team dates.</div>
            <a class="button inv m-tx1" href="/hris">Connect HRIS</a>
          </div>
          <div v-if="section === 'active-celebrations'">
            <div class="t bold">Sending {{ pointsNoun }} to employees with dates in the Celebrations channels below</div>
            <div class="t m-tx1">{{ celebrationPrograms.join(', ') }}</div>
          </div>
          <div v-if="section === 'inactive-celebrations'">
            <div class="t bold">Sync dates from a Celebrations channel</div>
            <div class="t m-tx1">Celebrations channels are required</div>
            <a class="button inv m-tx1" href="/channel_programs/new?preview=celebrations">Create Celebrations channel</a>
          </div>
        </div>
      </template>
    </donut-page-sections-two-column>
  </div>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';

  const $i18n = inject('$i18n');
  const { state } = useStore();

  const pointsNoun = $i18n.t('shoutouts.point', { count: 2 });

  const celebrationPrograms = computed(() => state.bonusMilestoneConfigs.celebrationPrograms);
  const hrisCategories = computed(() => state.hrisRecipientsRuleSelector.hrisCategories);

  const displayLogic = computed(() => {
    if (hrisCategories.value) {
      return {
        description: 'Dates are automatically synced from your connected HRIS for complete coverage. Select who is eligible to '
          + 'receive these automated milestone bonuses.',
        sections: ['active-hris'],
      };
    } else if (celebrationPrograms.value.length) {
      return {
        description: 'Recipients are currently synced from your active Celebrations channels. Only employees who have dates '
          + 'in Celebrations will receive this milestone bonus. Connect an HRIS for 100% team coverage.',
        sections: ['active-celebrations', 'inactive-hris'],
      };
    }
      return {
        description: `To automatically send milestone ${pointsNoun}, Donut needs to know your team's dates. Connect your HRIS or create `
          + 'a celebrations channel to start syncing your recipients.',
        sections: ['inactive-hris', 'inactive-celebrations'],
        alert: {
          title: `No one is receiving milestone ${pointsNoun} yet`,
          subtitle: 'Please set up recipient sources below',
        },
      };
  });
</script>
